import { Component, computed, inject, input } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpTextComponent } from '@features/lp/lp-text/lp-text.component';
import { getFontSize } from '@features/lp/lp-text/lp-text.utils';
import { StyleSheetSpriteComponent } from '@features/styles/style-sheet-sprite/style-sheet-sprite.component';
import { StylesService } from '@features/styles/styles.service';
import { LpTextCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-text-canvas-component',
  imports: [StyleSheetSpriteComponent, LpTextComponent],
  templateUrl: './lp-text-canvas-component.component.html',
  styleUrl: './lp-text-canvas-component.component.css',
})
export class LpTextCanvasComponentComponent {
  readonly _stylesService = inject(StylesService);

  comp = input.required<LpTextCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  textStyle = computed(() => ({
    fontSize: getFontSize(this.comp().style),
  }));
}
